import { OrderItem } from './order-item.model';
import { PaymentAdjustment } from './payment-adjustment.model';

/**
 * Model representing a request to create an order, containing details about the items, adjustments, and callback URLs for handling the order processing.
 */
export class OrderRequest {
  items: readonly OrderItem[];
  adjustments: readonly PaymentAdjustment[];
  callbackUrl: string;
  successUrl: string;
  failureUrl: string;
  totalAmount: number;
  totalItems: number;
  providerId: number | string;
  orderId: string;

  constructor(o?: Partial<OrderRequest>) {
    o = o || {};
    this.items = o?.items || [];
    this.adjustments = o?.adjustments || [];
    this.callbackUrl = o?.callbackUrl || '';
    this.successUrl = o?.successUrl || '';
    this.failureUrl = o?.failureUrl || '';
    this.totalAmount = o?.totalAmount || 0;
    this.totalItems = o?.totalItems || 0;
    this.providerId = o?.providerId || '';
    this.orderId = o?.orderId || '';
  }
}
